export const FIERY_ROUTE_STARTING_LIVES = 3;
export const FIERY_ROUTE_INVULNERABILITY_MS = 1_500;
export const FIERY_ROUTE_CORRECT_SCORE = 100;
export const FIERY_ROUTE_WRONG_GATE_PENALTY = 25;
export const FIERY_ROUTE_MAX_STREAK_BONUS = 40;
/** Normal modda yanlış kapıdan sonra doğru kapının gösterildiği süre (kamera yaklaşması dahil). */
export const FIERY_ROUTE_ANSWER_REVEAL_MS = 3_400;

export type EnemyProfile = {
  count: number;
  speed: number;
  repathMs: number;
};

export function enemyProfileForLevel(level: number): EnemyProfile {
  const safeLevel = Math.max(1, Math.min(10, Math.trunc(level)));
  if (safeLevel <= 2) return { count: 2, speed: 88, repathMs: 420 };
  if (safeLevel <= 5) return { count: 3, speed: 98, repathMs: 350 };
  if (safeLevel <= 8) return { count: 3, speed: 116, repathMs: 250 };
  return { count: 4, speed: 122, repathMs: 220 };
}

export function scoreAfterCorrect(score: number, streak: number): { score: number; streak: number } {
  const nextStreak = streak + 1;
  return {
    score: score + FIERY_ROUTE_CORRECT_SCORE + Math.min(FIERY_ROUTE_MAX_STREAK_BONUS, (nextStreak - 1) * 10),
    streak: nextStreak,
  };
}

export function scoreAfterWrongGate(score: number): number {
  return Math.max(0, score - FIERY_ROUTE_WRONG_GATE_PENALTY);
}
